// -----------------------------------------------------------------------------
// SOCIAL BAR
// -----------------------------------------------------------------------------
$(document).ready(function() {
	if ( $('.slink').length ) {
		initSocials($("body"))
	}
});

function initSocials($container) {
	$container.find('.slink').click(function(e) {
		e.stopPropagation();

		var width  = 600,
			height = 400,
			left   = ($(window).width() - width)  / 2,
			top    = ($(window).height() - height) / 2,
			url    = this.href,
			opts   = 'status=1' +
					 ',width='  + width  +
					 ',height=' + height +
					 ',top='    + top    +
					 ',left='   + left;
		window.open(url, 'myWindow', opts);
		return false;

		//$("#sframe").attr("src", this.href);
		//$("#popup").addClass("popup");
	});
}
